module.exports = __webpack_public_path__ + "img/Average time on market.9680afff.jpg";